/**
 * Serialize EmailModal attachments for /emails/send.
 * Auto-attached PDFs use `.blob`; user paperclip uploads use `.file`.
 */
export async function serializeEmailAttachments(emailAttachments = []) {
  const attachments = [];
  for (const item of emailAttachments) {
    const source = item?.blob || item?.file;
    if (!source) continue;

    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(String(reader.result || "").split(",")[1] || "");
      reader.onerror = reject;
      reader.readAsDataURL(source);
    });

    attachments.push({
      filename: item.filename || item.name || "attachment",
      content: base64,
      content_type: item.content_type || source.type || "application/octet-stream",
      size: item.size || source.size || 0,
    });
  }
  return attachments;
}
